/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Verify_PendingInputs */

const en_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verification pending -- expires ${i?.date}`)
};

const de_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verifizierung ausstehend -- läuft ab am ${i?.date}`)
};

const fr_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vérification en attente -- expire le ${i?.date}`)
};

const es_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verificación pendiente -- expira el ${i?.date}`)
};

const it_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verifica in corso -- scade ${i?.date}`)
};

const nl_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verificatie in afwachting -- vervalt op ${i?.date}`)
};

const pl_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weryfikacja w toku -- wygaśnie ${i?.date}`)
};

const fi_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Varmistus odottaa -- vanhenee ${i?.date}`)
};

const da_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verifikation afventer — udløber ${i?.date}`)
};

const sv_settings_verify_pending = /** @type {(inputs: Settings_Verify_PendingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verifiering väntar -- löper ut ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Verification pending -- expires {date}" |
*
* @param {Settings_Verify_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_verify_pending = /** @type {((inputs: Settings_Verify_PendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Verify_PendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_verify_pending(inputs)
	if (locale === "fr") return fr_settings_verify_pending(inputs)
	if (locale === "es") return es_settings_verify_pending(inputs)
	if (locale === "it") return it_settings_verify_pending(inputs)
	if (locale === "nl") return nl_settings_verify_pending(inputs)
	if (locale === "pl") return pl_settings_verify_pending(inputs)
	if (locale === "fi") return fi_settings_verify_pending(inputs)
	if (locale === "da") return da_settings_verify_pending(inputs)
	if (locale === "sv") return sv_settings_verify_pending(inputs)
	return en_settings_verify_pending(inputs)
});